import { Stack, Grid } from '@mui/material';
import React from 'react';

import { ServiceNewCheckInProps } from './ServiceNewCheckIn.props';
import {
  ContentPaper,
  TravelStartText,
  NoTravelText,
  NotesText,
  StyledDivider
} from './ServiceNewCheckIn.styles';
import { DateTimePicker } from '../../atoms/DateTimePicker';
import { Typography, TypographyVariantProps } from '../../atoms/Typography';
import { AllocatedServices } from '../../molecules/AllocatedServices';
import { EditDateTimePicker } from '../../molecules/EditDateTimePicker';

export const ServiceNewCheckIn: React.FC<ServiceNewCheckInProps> = ({
  travelStart,
  onSiteTime,
  noteText,
  onChangeTravelStart,
  onChangeOnSiteTime,
  onNoteText,
  onChangeAllocation,
  allocatedServiceData,
  allocatedServicesLoading,
  multiOnSiteSuggestionsAvailable
}) => {
  return (
    <ContentPaper mb={2} width="100%">
      <Grid container spacing={4}>
        <Grid
          size={{
            xs: 12,
            md: 4
          }}>
          {!travelStart && <NoTravelText>No Travel time detected, what time did you depart for this service ?</NoTravelText>}
          <Stack direction="row" alignItems="center" mb={2}>
            {travelStart ?
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant={TypographyVariantProps.Body2}>Travel Time Began:</Typography>
                <EditDateTimePicker
                  isEditable={true}
                  disableFuture={true}
                  value={travelStart}
                  textFontSize="0.875rem"
                  onChange={onChangeTravelStart}
                />
              </Stack>
              :
              <>
                <TravelStartText variant={TypographyVariantProps.Body2}>Travel Start:</TravelStartText>
                <DateTimePicker
                  label=""
                  disableFuture={true}  
                  value={travelStart}
                  onChange={onChangeTravelStart}
                />
              </>
            }
          </Stack>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant={TypographyVariantProps.Body2}>On Site Time:</Typography>
            <EditDateTimePicker
              isEditable={true}
              disableFuture={true}
              value={onSiteTime}
              textFontSize="0.875rem"
              onChange={onChangeOnSiteTime}
            />
          </Stack>
        </Grid>
        <Grid
          width="100%"
          size={{
            xs: 12,
            md: 8
          }}>
          <NotesText
            label="Notes"
            fullWidth
            multiline
            rows={2}
            value={noteText}
            onChange={(text) => onNoteText(text)}
          />
        </Grid>
      </Grid>
      {multiOnSiteSuggestionsAvailable && allocatedServiceData.length !== 0 && (
        <>
          <StyledDivider/>
          <Typography>Other Services at this location:</Typography>
          <AllocatedServices onChange={onChangeAllocation} allocatedServiceData={allocatedServiceData} allocatedServicesLoading={allocatedServicesLoading} />
        </>
      )}
    </ContentPaper>
  );
};